<template>
  <div v-if="loading" class="overlay">
    <div class="loader"></div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();

    const loading = computed(() => store.state.loading);
    return { loading }
  }
}
</script>

<style>
.overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(42, 84, 138, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}


.loader {
  border: 10px solid #f3f3f3; /* Light grey */
  border-top: 10px solid #3498db; /* Blue */
  border-radius: 50%;
  z-index: 9999;
  width: 80px;
  height: 80px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


</style>